import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export const getShipmentSortingFieldsListAPI = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SHIPMENT}/ShipmentSearchOrderByList`,
  });
};

export type ShipmentSortingFieldsListResponse = {
  id: number;
  columnName: string;
  columnValue: string;
}[];

export const fetchShipmentSortingFieldsList = async (): Promise<ShipmentSortingFieldsListResponse> => {
  const response: AxiosResponse<ShipmentSortingFieldsListResponse> = await getShipmentSortingFieldsListAPI();
  return response.data;
};
